const sliderTop = () => {
	let sliderTopSwiper = new Swiper('.slider-top__container', {
		slidesPerView: 1,
		spaceBetween: 0,
		freeMode: true,
		loop: true,
	});
}

export default sliderTop;